import { docReady } from '../helpers/docReady';
import '../../styles/templates/search.scss';
docReady(() => {
    // console.log('Search Template');
});
